module.exports = __webpack_public_path__ + "img/04.17d7f37c.svg";